// extracted by mini-css-extract-plugin
export default {"menuBlock":"UI-z","title":"VI-z","nav":"WI-z","flexCell":"XI-z","facetLink":"YI-z"};